const FEED_VIEW_DESKTOP_HOOK_NAME = 'feed-view-desktop';

const FEED_VIEW_DESKTOP_VERSIONS = {
    VISIBLE: 'original-article-visible-under-feed-view',
    INVISIBLE: 'original-article-hidden-under-feed-view'
};

class FeedViewDesktop {
    constructor(box, data, options) {
        this.box = box;
        this.data = data;
        this.config = FeedViewDesktop.getFeedViewDesktopConfig(options);
        TRC.customHooks[FEED_VIEW_DESKTOP_HOOK_NAME].didAspect = false;
        this.addedPopStateListener = false;
        TRC.aspect.after(box.rbox, 'openFeedView', () => {
            if (!TRC.customHooks[FEED_VIEW_DESKTOP_HOOK_NAME].didAspect) {
                this.openFeedViewDesktop();
            }
        }, false);
    }

    openFeedViewDesktop() {
        TRC.customHooks[FEED_VIEW_DESKTOP_HOOK_NAME].didAspect = true;
        TRCImpl.sendAbTestEvent(FeedViewDesktop.GENERAL_EVENT_NAME, FeedViewDesktop.AB_TEST_EVENT_TYPES.ON_IFRAME_OPEN);
        if (this.config.version === FEED_VIEW_DESKTOP_VERSIONS.VISIBLE) {
            const feedViewIframe = document.getElementById(FeedViewDesktop.CSS_CLASSES.FEED_VIEW_CONTAINER);
            TRC.dom.addClass(feedViewIframe, FeedViewDesktop.CSS_CLASSES.BORDERED_IFRAME);
            feedViewIframe.insertAdjacentHTML('afterbegin', FeedViewDesktop.createCloseButtonMarkup());
            TRC.dom.on(document.getElementById(FeedViewDesktop.CSS_CLASSES.CLOSE_BTN_WRAPPER), 'click', FeedViewDesktop.handleCloseBtnClick);
        } else {
            const htmlElement = document.getElementsByClassName(FeedViewDesktop.CSS_CLASSES.FEED_VIEW_PARENT_WRAPPER)[0];
            TRC.dom.addClass(htmlElement, FeedViewDesktop.CSS_CLASSES.HIDDEN_ARTICLE);
        }
        this.iframe = document.getElementById(FeedViewDesktop.CSS_CLASSES.IFRAME_ID);
        this.addEventListeners();
    }

    addEventListeners() {
        TRC.dom.on(this.iframe, 'load', this.onLoad.trcBind(this));
        TRC.dom.on(this.iframe.contentWindow, 'DOMContentLoaded', FeedViewDesktop.onContentReady);
        if (!this.addedPopStateListener) {
            this.addedPopStateListener = true;
            TRC.dom.on(window, 'popstate', () => { this.onPopState.trcBind(this)(); });
        }
    }

    onPopState() {
        TRCImpl.sendAbTestEvent(FeedViewDesktop.GENERAL_EVENT_NAME, FeedViewDesktop.AB_TEST_EVENT_TYPES.ON_IFRAME_CLOSE_BACK);
        if (TRC.FeedView.isFeedViewState()) {
            if (this.config.version === FEED_VIEW_DESKTOP_VERSIONS.INVISIBLE) {
                TRC.dom.removeClass(document.documentElement, FeedViewDesktop.CSS_CLASSES.HIDDEN_ARTICLE);
            }
            TRC.customHooks[FEED_VIEW_DESKTOP_HOOK_NAME].didAspect = false; 
        } 
    }

    onLoad() {
        TRCImpl.sendAbTestEvent(FeedViewDesktop.GENERAL_EVENT_NAME, FeedViewDesktop.AB_TEST_EVENT_TYPES.ON_IFRAME_LOAD);
        this.onUnload = () => {
            TRCImpl.sendAbTestEvent(FeedViewDesktop.GENERAL_EVENT_NAME, FeedViewDesktop.AB_TEST_EVENT_TYPES.ON_IFRAME_UNLOAD);
        };
        TRC.dom.on(this.iframe.contentWindow, 'unload', this.onUnload);
    }

    static onContentReady() {
        TRCImpl.sendAbTestEvent(FeedViewDesktop.GENERAL_EVENT_NAME, FeedViewDesktop.AB_TEST_EVENT_TYPES.LOAD_START);
    }

    static getFeedViewDesktopConfig(options = {}) {
        const version = options.version === 'invisible' ? FEED_VIEW_DESKTOP_VERSIONS.INVISIBLE : FEED_VIEW_DESKTOP_VERSIONS.VISIBLE;
        return {version};
    }

    static handleCloseBtnClick() {
        TRCImpl.sendAbTestEvent(FeedViewDesktop.GENERAL_EVENT_NAME, FeedViewDesktop.AB_TEST_EVENT_TYPES.ON_IFRAME_CLOSE_X);
        const container = document.getElementById(FeedViewDesktop.CSS_CLASSES.FEED_VIEW_CONTAINER);
        TRC.FeedView.removeIframe(null, container, null, null, null, null, true, true, false);
        TRC.customHooks[FEED_VIEW_DESKTOP_HOOK_NAME].didAspect = false;
    }

    static createCloseButtonMarkup() {
        return `
            <div id="${FeedViewDesktop.CSS_CLASSES.CLOSE_BTN_WRAPPER}">
                <div class="${FeedViewDesktop.CSS_CLASSES.CLOSE_BTN}">
                   <svg class="${FeedViewDesktop.CSS_CLASSES.CLOSE_BTN_X}" width="12px" height="12px" viewBox="0 0 10 10">
                     <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                       <g id="icons" transform="translate(-23.000000, -130.000000)">
                          <polygon id="Desktop-Close-initial" points="33 131.208868 31.7911325 130 28 133.791132 24.2088675 130 23 131.208868 26.7911325 135 23 138.791132 24.2088675 140 28 136.208868 31.7911325 140 33 138.791132 29.2088675 135"></polygon>
                       </g>
                     </g>
                   </svg>
                </div>
            </div>`;
    }

    static disableFeedViewDeskForItem(box, data) {
        return box.rbox.isFeedCard !== true || TRC.dom.isSmartPhone() || data.isSyndicated === 'true';
    }
}

(() => {
    FeedViewDesktop.hooks = {
        'item-renderer': function (box, data) {
            const isfeedViewDesktopSupportedBrowser = box.rbox.trc.feedViewDesktopSupportedBrowser;
            box.rbox.enableFeedView = typeof isfeedViewDesktopSupportedBrowser === 'undefined' ? FeedViewDesktop.isSupportedBrowser() : isfeedViewDesktopSupportedBrowser;
            if (box.rbox.enableFeedView && !(FeedViewDesktop.disableFeedViewDeskForItem(box, data))) {
                box.rbox.trc.feedViewDesktopSupportedBrowser = true;
                const cmm = TRC.CustomModulesManager;
                const options = (cmm && cmm.registeredModules && cmm.registeredModules[FEED_VIEW_DESKTOP_HOOK_NAME].options) || {};
                new FeedViewDesktop(box, data, options);
            } else if (!box.rbox.enableFeedView && typeof isfeedViewDesktopSupportedBrowser === 'undefined') {
                box.rbox.trc.feedViewDesktopSupportedBrowser = false;
                box.rbox.trc.sendAbTestEvent(FeedViewDesktop.UNSUPPORTED_BROWSER_EVENT, {browser: FeedViewDesktop.unsupportedBrowser});
            }
        }
    };

    FeedViewDesktop.isSupportedBrowser = () => {
        FeedViewDesktop.setBrowserIfUnsupported();
        return !(FeedViewDesktop.unsupportedBrowser);
    };

    FeedViewDesktop.setBrowserIfUnsupported = () => {
        if (TRC.Browser.ie) {
            FeedViewDesktop.unsupportedBrowser = FeedViewDesktop.UNSUPPORTED_BROWSERS.INTERNET_EXPLORER;
        } else if (window.navigator.userAgent.indexOf('Edge') > -1) {
            FeedViewDesktop.unsupportedBrowser = FeedViewDesktop.UNSUPPORTED_BROWSERS.MICROSOFT_EDGE; 
        } else if (window.navigator.userAgent.indexOf('Edg') > -1) {
            FeedViewDesktop.unsupportedBrowser = FeedViewDesktop.UNSUPPORTED_BROWSERS.CHROMIUM_EDGE;
        } else {
            FeedViewDesktop.unsupportedBrowser = null;
        }
    };

    FeedViewDesktop.CSS_CLASSES = {
        CLOSE_BTN: 'tbl-fvd-close-btn',
        CLOSE_BTN_X: 'tbl-fvd-close-btn-x',
        CLOSE_BTN_WRAPPER: 'tbl-fvd-close-btn-wrapper',
        IFRAME_ID: 'tbl-feed-view-frame',
        FEED_VIEW_PARENT_WRAPPER: 'tbl-feed-view-parent-wrapper',
        HIDDEN_ARTICLE: 'tbl-feed-view-hidden-article',
        BORDERED_IFRAME: 'tbl-feed-view-bordered-iframe',
        FEED_VIEW_CONTAINER: 'tbl-feed-view-container'
    };

    FeedViewDesktop.GENERAL_EVENT_NAME = 'feedView_desktop_iframe_pv';
    FeedViewDesktop.UNSUPPORTED_BROWSER_EVENT = 'feedView_desktop_unsupported_browser';

    FeedViewDesktop.AB_TEST_EVENT_TYPES = {
        ON_IFRAME_OPEN: 'on_iframe_open',
        ON_IFRAME_CLOSE_BACK: 'on_iframe_close_back',
        ON_IFRAME_LOAD: 'on_iframe_load',
        ON_IFRAME_UNLOAD: 'on_iframe_unload',
        ON_IFRAME_CLOSE_X: 'on_iframe_close_x',
        LOAD_START: 'load_start'
    };

    FeedViewDesktop.UNSUPPORTED_BROWSERS = {
        INTERNET_EXPLORER: 'ie',
        MICROSOFT_EDGE: 'microsoft_edge',
        CHROMIUM_EDGE: 'chromium_edge'
    };

    TRC.customHooks[FEED_VIEW_DESKTOP_HOOK_NAME] = FeedViewDesktop;
})();